// 正式
module.exports = {
  title: '',
  baseUrl: 'https://www.xxx.com/',
  // 正式项目地址
  baseApi: 'https://www.xxx.com/api',
  // 正式api请求地址
  APPID: 'xxx',
  APPSECRET: 'xxx'
  // $cdn: 'https://www.sunniejs.cn/static'
};